/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { PersonRolleCountListEntryMeta } from './personRolleCountListEntryMeta';
import { PersonStammVersionDetailEntryMeta } from './personStammVersionDetailEntryMeta';
import { EsMatchInformation } from './esMatchInformation';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammMasterListEntryMeta { 
    printRTFpossible?: boolean;
    mPrintRTFpossible?: FieldMetaData;
    diffHint?: boolean;
    mDiffHint?: FieldMetaData;
    uebrigeBerechtigteCount?: PersonRolleCountListEntryMeta;
    mUebrigeBerechtigteCount?: FieldMetaData;
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    eigentumCount?: PersonRolleCountListEntryMeta;
    mEigentumCount?: FieldMetaData;
    glaeubigerCount?: PersonRolleCountListEntryMeta;
    mGlaeubigerCount?: FieldMetaData;
    match?: EsMatchInformation;
    mMatch?: FieldMetaData;
    printPDFpossible?: boolean;
    mPrintPDFpossible?: FieldMetaData;
    masterId: PersonStammMasterId;
    mMasterId?: FieldMetaData;
    auskunftsperre?: PersonStammMasterListEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    schuldnerCount?: PersonRolleCountListEntryMeta;
    mSchuldnerCount?: FieldMetaData;
    version?: PersonStammVersionDetailEntryMeta;
    mVersion?: FieldMetaData;
}
export namespace PersonStammMasterListEntryMeta {
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFT_SPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESS_SPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


